export const environment = {
  name: 'dev',
  production: false,
  apiUrl:'https://portal-sisben-sititramites.sitiapp.com',
  recaptchaV2SiteKey: '6Lcz3Y4UAAAAAABU_4GbwsF7CWX_fVF0vlH-3HGK',
  recaptchaV3SiteKey: '6LcvhecUAAAAAMJMopps30WHSsMPMrxCWK5O0Lk1',
  portalUrl:'https://portal-gobmag.sitiapp.com',
  recaptchaIgnore: false,
};

